import {Snackbar} from '@/models/snackbar.interface';
import {TiposMutationSnackbar} from './tipos-mutation.snackbar';
import {MapActionsSnackbar} from './map-actions.snackbar';

export default {
    namespaced: true,
    state: () => ({
        color: '',
        show: false,
        time: -1,
        mensagem: '',
    }),
    mutations: {
        // @ts-ignore
        [TiposMutationSnackbar.SET_COLOR](state: any, color: string) {
            state.color = color;
        },
        // @ts-ignore
        [TiposMutationSnackbar.SET_SHOW](state: any, show: boolean) {
            state.show = show;
        },
        // @ts-ignore
        [TiposMutationSnackbar.SET_TIME](state: any, time: number) {
            state.time = time;
        },
        // @ts-ignore
        [TiposMutationSnackbar.SET_MENSAGEM](state: any, mensagem: string) {
            state.mensagem = mensagem;
        },
    },
    actions: {
        // @ts-ignore
        [MapActionsSnackbar.SET_SNACKBAR_SHOW]({commit}, show: boolean) {
            commit(TiposMutationSnackbar.SET_SHOW, show);
        },
        // @ts-ignore
        [MapActionsSnackbar.SET_SNACKBAR]({commit}, snackbar: Snackbar) {
            commit(TiposMutationSnackbar.SET_COLOR, snackbar.color);
            commit(TiposMutationSnackbar.SET_SHOW, true);
            commit(TiposMutationSnackbar.SET_TIME, snackbar.time);
            commit(TiposMutationSnackbar.SET_MENSAGEM, snackbar.mensagem);
        },
        // @ts-ignore
        [MapActionsSnackbar.SET_SNACKBAR_SUCCESS]({commit}, mensagem: string) {
            if (mensagem !== undefined && mensagem !== null) {
                const quantidadePalavras = mensagem.toString().split(' ').length;
                const time = 385 * quantidadePalavras;
                commit(TiposMutationSnackbar.SET_COLOR, '#008597');
                commit(TiposMutationSnackbar.SET_SHOW, true);
                commit(TiposMutationSnackbar.SET_TIME, Math.max(5000, time));
                commit(TiposMutationSnackbar.SET_MENSAGEM, mensagem);
            } else {
                console.error(`MENSAGEM PASSADA NO ${MapActionsSnackbar.SET_SNACKBAR_SUCCESS} ESTÁ VAZIA!`);
            }
        },
        // @ts-ignore
        [MapActionsSnackbar.SET_SNACKBAR_ERROR]({commit}, mensagem: string) {
            if (mensagem !== undefined && mensagem !== null) {
                const quantidadePalavras = mensagem.toString().split(' ').length;
                const time = 385 * quantidadePalavras;
                commit(TiposMutationSnackbar.SET_COLOR, '#FF0000');
                commit(TiposMutationSnackbar.SET_SHOW, true);
                commit(TiposMutationSnackbar.SET_TIME, Math.max(5000, Math.min(15000, time)));
                commit(TiposMutationSnackbar.SET_MENSAGEM, mensagem);
            } else {
                console.error(`MENSAGEM PASSADA NO ${MapActionsSnackbar.SET_SNACKBAR_ERROR} ESTÁ VAZIA!`);
            }
        },
    },
    getters: {
        color: (state: any) => state.color,
        show: (state: any) => state.show,
        time: (state: any) => state.time,
        mensagem: (state: any) => state.mensagem,
    },
};
